<template>
  <div class="block-transaction-table">
    <table class="table">
      <thead>
        <tr>
          <th>{{ $t("table.from") }}</th>
          <th>{{ $t("table.to") }}</th>
          <th class="is-hidden-mobile">{{ $t("table.hash") }}</th>
          <th>{{ $t("table.amount") }}</th>
        </tr>
      </thead>
      <tbody v-for="transaction in transactions" :key="transaction.hash">
        <tr>
          <!-- from -->
          <td class="from">
            <a v-bind:href="'#/account/'+ transaction.from">
              <code class="has-text-info">{{ transaction.from }}</code>
            </a>
          </td>
          <!-- to -->
          <td class="to">
            <a v-if="!isContract(transaction)" v-bind:href="'#/account/'+ transaction.to">
              <code class="has-text-info">{{ transaction.to }}</code>
            </a>
            <span v-if="isContract(transaction)">
              {{ typeDesc(transaction) }}
              <b-icon pack="fa" icon="file-text" type="is-primary" size="is-small"></b-icon>
              <a v-bind:href="'#/account/'+ transaction.to">
                <code class="has-text-info">{{ transaction.to }}</code>
              </a>
            </span>
          </td>
          <!-- hash -->
          <td class="hash is-hidden-mobile">
            <a v-bind:href="'#/tx/'+ $utils.formatHash(transaction.hash)">
              <code class="has-text-info">{{ $utils.formatHash(transaction.hash) }}</code>
            </a>
          </td>
          <!-- amount -->
          <td class="amount has-text-success">
            {{ $utils.formatAmount(transaction.value) }} <!-- {{ coinName }} -->
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
  export default {
    name: 'block-transaction-table',
    props: ['transactions'],
    methods: {
      typeDesc (t) {
        if (t.what === 'contract_creation') {
          return this.$t('table.contract_creation')
        }
        return ''
      },
      isContract (t) {
        return t.what !== ''
      }
    },
    computed: {
      coinName () {
        return this.$COINNAME
      }
    }
  }
</script>

<style lang="scss" scoped>
  table {
    width: 100%;
  }

  td {
    max-width: 0;
    overflow: hidden;
    word-break: break-word;
  }

  td.from {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  td.to {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  td.hash {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
</style>



// WEBPACK FOOTER //
// src/components/layout/BlockTransactionTable.vue